<template>
  <div>
    <FormulaBanner :title="title" :formulaCode="formulaCode"/>
    <div class="index">
      <!-- 表单 -->
      <div>
        <div class="top_nav"><span></span>{{title}}
        </div>
        <div class="formBody">
          <!-- 表单 -->
          <van-form @submit="onSubmit">
            <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
            <van-field
                v-model="tizhong"
                :rules="[{ required: true, message: '请输入' }]"
            >
              <template #input>
                <div class="titles">
                  <span class="titlesName">体重 <i>*</i></span>
                  <span style="display: flex;">
                   <span class="information">
                     <van-cell-group class="vanCell">
                       <van-field input-align="right" type="number" v-model="tizhong" placeholder="请输入" />
                     </van-cell-group>
                   </span>
                    <div class="unit"><span>kg</span></div>
                 </span>
                </div>
              </template>
            </van-field>
            <van-field
                v-model="shaoshangmianjibi"
                :rules="[{ required: true, message: '请输入' }]"
            >
              <template #input>
                <div class="titles">
                  <span class="titlesName">烧伤面积比 <i>*</i></span>
                  <span style="display: flex;align-items: center;">
                   <span class="information">
                     <van-cell-group class="vanCell">
                       <van-field input-align="right" type="number" v-model="shaoshangmianjibi" placeholder="请输入" />
                     </van-cell-group>
                   </span>
                    <div class="unit"><span>%</span></div>
                 </span>
                </div>
              </template>
            </van-field>
            <van-field
                v-model="shaoshanghoushichang"
                :rules="[{ required: true, message: '请填写小于等于7的数字', validator:niaoniaoVa},]"
            >
              <template #input>
                <div class="titles">
                  <span class="titlesName">烧伤后时长 <i>*</i></span>
                  <span style="display: flex;align-items: center;">
                   <span class="information">
                     <van-cell-group class="vanCell">
                       <van-field input-align="right" type="number" v-model="shaoshanghoushichang" placeholder="请输入" />
                     </van-cell-group>
                   </span>
                    <div class="unit"><span>h</span></div>
                 </span>
                </div>
              </template>
            </van-field>
            <van-field
                v-model="muqianbuyeliang"
                :rules="[{ required: true, message: '请输入' }]"
            >
              <template #input>
                <div class="titles">
                  <span class="titlesName">目前补液量 <i>*</i></span>
                  <span style="display: flex;align-items: center;">
                   <span class="information">
                     <van-cell-group class="vanCell">
                       <van-field input-align="right" type="number" v-model="muqianbuyeliang" placeholder="请输入" />
                     </van-cell-group>
                   </span>
                    <div class="unit"><span>ml</span></div>
                 </span>
                </div>
              </template>
            </van-field>
            <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
              <van-button class="formula-template-button"  block type="info" native-type="submit" style="width:90px">提交</van-button>
            </div>
          </van-form>
          <!-- 计算结果 -->
          <!-- <div class="CalculationResultsBox" v-if="countText || countText !== ''">
            <div class="CalculationResults"><span>计算结果</span></div>
            <div>
              <div class="CalculationDetail"><span></span>{{result1}}</div>
            </div>
            <div>
              <div class="CalculationDetail"><span></span>{{result2}}</div>
            </div>
            <div>
              <div class="CalculationDetail"><span></span>{{result3}}</div>
            </div>
            <div>
              <div class="CalculationDetail"><span></span>{{result4}}</div>
            </div>
            <div>
              <div class="CalculationDetail"><span></span>{{result5}}</div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- 计算结果 -->
      <CalculationResults v-if="show" :styleA="{justifyContent: 'flex-start',fontSize: '17px'}" :countText="countText1" :countTextList="countTextList"></CalculationResults>
      <!-- 后台设置的值 -->
      <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
      <!-- 参考文献 -->
      <FormulaReferences :references-data="tableData.references"></FormulaReferences>
    </div>

  </div>

</template>

<script>
import MyPatient from '@/components/MyPatient.vue'
import FormulaBanner from '@/components/FormulaBanner.vue'
import {Toast} from "vant";
import {getAdmins} from "@/utils/adminDate";
import {setById} from "@/service/base";
import {getFormula, getFormulaHuiXian, postFormula} from "@/service/BodyMassIndex_api";
import FormulaExplain from "@/components/template1/FormulaExplain";
import FormulaReferences from "@/components/template1/FormulaReferences";
import CalculationResults from "@/components/CalculationResults";
export default {
  name: "medicalSearch",
  data(){
    return{
      compute:true,
      show:false,
      countText1:'',
      countTextList:[],
      muqianbuyeliang: '',
      shaoshanghoushichang: '',
      shaoshangmianjibi: '',
      tizhong: '',
      shousuoya: '',
      shuzhangya: '',
      formulaCode: '',
      xueqingjigan: '',
      niaojigan: '',
      xueniaosudan: '',
      title: '',
      memberId: '1111',
      selectValue: '',
      username:"",
      value:"",
      showPopover: false,
      showPicker: false,
      nianling: '',
      xingbie: null,
      tableData: {},
      countText: '',
      patientId: null,
      result: null,
      niaoniaosu: '',
      result1: '',
      result2: '',
      result3: '',
      result4: '',
      result5: '',
      result1Value: '',
      result2Value: '',
      result3Value: '',
      result4Value: '',
      result5Value: '',
    }
  },
  components: {
    FormulaExplain,
    FormulaBanner,
    MyPatient,
    FormulaReferences,
    CalculationResults
  },
  async created() {
    await this.test()
    await this.getTableData()
  },
  watch:{
    "muqianbuyeliang":{
      immediate:true,
      handler:function(){
        this.show = false;
      }
    },
    "shaoshanghoushichang":{
      immediate:true,
      handler:function(){
        this.show = false;
      }
    },
    "shaoshangmianjibi":{
      immediate:true,
      handler:function(){
        this.show = false;
      }
    },
    "tizhong":{
      immediate:true,
      handler:function(){
        this.show = false;
      }
    },

  },
  methods:{
    niaoniaoVa () {
      return Number(this.shaoshanghoushichang) <= 7
    },
    coumputTetxt () {
      // let gongshi = ''
      let jisuan = ''
      let qty = 0
      jisuan = this.shaoshangmianjibi * this.tizhong * 4
      jisuan = jisuan.toFixed(1)
      this.result1Value = jisuan
      this.result1 = `(首个24h)液体需要量：${jisuan} ml`
      qty = jisuan
      jisuan = qty / 2 - Number(this.muqianbuyeliang)
      jisuan = jisuan.toFixed(1)
      this.result2Value = jisuan
      this.result2 = `(前${8 - Number(this.shaoshanghoushichang)}h)起始补液量：${jisuan} ml`
      jisuan = jisuan / (8 - this.shaoshanghoushichang)
      jisuan = jisuan.toFixed(1)
      this.result3Value = jisuan
      this.result3 = `(前${8 - this.shaoshanghoushichang}h)起始补液速度：${jisuan} ml/h`
      jisuan = qty / 2
      jisuan = jisuan.toFixed(1)
      this.result4Value = jisuan
      this.result4 = `(后16h)追加补液量：${jisuan} ml`
      jisuan = qty / 2 / 16
      jisuan = jisuan.toFixed(1)
      this.result5Value = jisuan
      this.result5 = `(后16h)追加补液速度：${jisuan} ml/h`
      this.countText = '完成'
      this.countTextList = []
      this.countTextList.push(this.result1,this.result2,this.result3,this.result4,this.result5) 
    },
    async test(){
      //像接口头部传用户信息
      let arrays = await getAdmins(this.$route.query.memberId,this.$route.query.channel)
      this.channel = arrays.os
      this.version = arrays.version
      this.ip = arrays.ip
      await setById(arrays)
    },
    async getTableData () {
      const data = {
        channel: this.$router.currentRoute.query.channel,
        code: 'TNMUWODI',
      }
      const res = await getFormula(data.channel, data.code)
      if (res.code === 0) {
        this.tableData = res.data
        this.formulaCode = res.data.code
        this.title = res.data.chineseName
      }
      if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
        const data = {
          id: this.$router.currentRoute.query.logId
        }
        const res = await getFormulaHuiXian(data)
        if (res.code === 0) {
          // this.tableData = res.data
          // this.formulaCode = res.data.code
          this.muqianbuyeliang = res.data.content.muqianbuyeliang.value
          this.shaoshanghoushichang = res.data.content.shaoshanghoushichang.value
          this.shaoshangmianjibi = res.data.content.shaoshangmianjibi.value
          this.tizhong = res.data.content.tizhong.value
          if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
          this.coumputTetxt()
        }
        // this.compute = false
      }
      this.$nextTick(() => {
        this.show=true
      })
    },
    async submit () {
      this.coumputTetxt()
    },
    calculateAge(birthDateString) {
      const today = new Date();
      const birthDate = new Date(birthDateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      // 如果今天的日期还没到生日月份和日期，则年龄减一
      if (today.getMonth() < birthDate.getMonth() ||
          (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    // 开参考文献链接
    openLink(u){
      if (!u) {
        return
      }
      //获取系统版本
      let userAI = navigator.userAgent;
      const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
      const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        // alert('安卓操作系统')
        // 这个是安卓操作系统
        window.open(u)
      }
      if (isIOS) {
        // 这个是ios操作系统
        // alert('ios操作系统')
        window.location.href = u
      }
    },
    yingjiClick () {
      this.showPicker = true
    },
    onConfirm(value) {
      this.yingjizhishu = value
      this.showPicker = false
    },
    onCancel() {
      this.showPicker = false
    },
    async onSubmit(){
      this.coumputTetxt()
      const data = {
        id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
        patientId: this.patientId,
        columnCode: this.tableData.columnCode,
        formulaCode: this.tableData.code,
        channel: this.$router.currentRoute.query.channel,
        location: this.$router.currentRoute.query.location,
        content: {
          tizhong: {value: this.tizhong, unit: 'kg'},
          shaoshangmianjibi: {value: this.shaoshangmianjibi, unit: '%'},
          shaoshanghoushichang: {value: this.shaoshanghoushichang, unit: 'h'},
          muqianbuyeliang: {value: this.muqianbuyeliang, unit: 'ml'},
        },
        result: {
          yetixuyaoliang: {value: this.result1Value, unit: 'ml'},
          qishibuyeliang: {value: this.result2Value, unit: 'ml'},
          qishibuyesudu: {value: this.result3Value, unit: 'ml/h'},
          zhuijiabuyeliang: {value: this.result4Value, unit: 'ml'},
          zhuijiabuyesudu: {value: this.result5Value, unit: 'ml/h'},
          DisplayResults:this.result1 + "；" +this.result2+ "；" + this.result3+ "；" + this.result4+ "；" + this.result5
        }
      }
      // if (this.xingbie == 1) {
      //   data.result.nanxing = {value: this.result, unit: 'kcal'}
      // } else {
      //   data.result.nvxing = {value: this.result, unit: 'kcal'}
      // }
      const res = await postFormula(data)
      if (res.code === 0) {
        Toast.success('提交成功')
        this.show=true
      } else {
        Toast.fail(res.message)
        this.show=true
      }
    },
    userChange (data) {
      if (data.birthday && data.birthday !== '') {
        this.nianling = this.calculateAge(data.birthday)
      } else {
        this.nianling = ''
      }
      this.xingbie = data.sex
      this.patientId = data.id
      this.selectValue = data
    },
  }
}
</script>


<style scoped lang="scss">
.index{
  background: #F6F6F6;
  padding: 10px 15px;
  height: 100%;
  .StandardDescription{
    margin-top:10px;
    .top_nav{
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom:10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .StandardDeatil{
      width:100%;
      padding:15px 10px;
      //   height: 50px;
      background-color: #fff;
      box-sizing: border-box;
    }
  }
  .top_nav{
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: start;
    margin-bottom:10px;
    span {
      display: inline-block;
      width: 5px;
      height: 15px;
      background: #259beb;
      margin-right: 5px;
    }
  }
  .formBody{
    background-color: #fff;
    padding-bottom:10px;
    .CalculationResultsBox{
      padding:0 8px;
      .CalculationResults{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        justify-content: center;
        margin-bottom:10px
      }
      .CalculationDetail{
        font-size: 15px;
        color: #333333;
        // font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom:10px;
        background-color: #f6f6f6;
        // height: 16px;
        span{
          display: inline-block;
          width: 3px;
          height: 24px;
          background: #fe9712;
          margin-right: 5px;
        }
      }
    }
  }
  .titles{
    display:flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    height: 50px;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 10px;
    box-sizing: border-box;
    .titlesName{
      font-size:16px;
      i{
        color: red;
      }
    }
    .information{
      font-size:16px;
      margin-right:4px;
      .PleaseSelect{
        color: #b9b9b9;
      }
      .vanCell{
        width:50px;
        padding:0;
        height: 100%;
      }
    }
    .vBotton{
      width:60px
    }
    .unit{
      height: 50px;
      //   line-height: 50px;
      display: flex;
      align-items: center;
      font-size:16px;
      width:20px;
    }
    .vanIcon{
      font-size:13px;
      color:#a8a8a8;
      font-weight: 650;
    }
  }
}
::v-deep .van-cell {
  padding:0px 0px;
}
::v-deep .van-field__control{
  height: 50px;
  font-size: 16px;
}
::v-deep .van-field__error-message {
  position: absolute;
  top: 30px;
  left: 10px;
}
.StandardDeatil2{
  width:100%;
  padding: 15px 10px;
  padding-bottom:1px;
  //   height: 50px;
  background-color: #fff;
  box-sizing: border-box;
  .references{
    margin-bottom:15px
  }
}
::v-deep p {
  padding: 0;
  margin: 0;
}
</style>
